export enum UserAgents {
    TEAMS = 305
}
